import { DropDown } from 'src/app/shared/model/base-model';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';


import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabViewModule } from 'primeng/tabview';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';

import { InputNumberModule } from 'primeng/inputnumber';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';

import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';


import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { WoOrderService } from 'src/app/core/services/wo-order/wo-order.service';
import { WoOrderServiceTemplateService } from './wo-order-service-template/wo-order-service-template.service';
import { WoOrderServiceTemplateGridComponent } from './wo-order-service-template/wo-order-service-template-grid/wo-order-service-template-grid.component';

import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { WoOrderServiceGridComponent } from './wo-order-service/wo-order-service-grid/wo-order-service-grid.component';
import { WoOrderServiceRoutingModule } from './wo-order-service.routing.module';
import { DividerModule } from 'primeng/divider';
import { SfSubHeaderModule } from 'src/app/shared/components/sub-header/sub-header.module';
import { SfBreadCrumbModule } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.module';
import { WoOrderServiceDetailComponent } from './wo-order-service/wo-order-service-detail/wo-order-service-detail.component';
import { WoOrderServiceDropdownComponent } from './wo-order-service/wo-order-service-dropdown/wo-order-service-dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { WoOrderOrderServiceDetailComponent } from '../wo-order-order-service/wo-order-service-detail/wo-order-order-service-detail.component';
import { ScModuleModule } from 'src/app/pages/sc-module/sc-module.module';
import { ScArchiveTypeModule } from '../sc-archive-type/sc-archive-type.module';
import { WoOrderServiceDefaultModule } from '../wo-order-service-default/wo-order-service-default.module';
import { ColorPickerModule } from 'primeng/colorpicker';

@NgModule({
    declarations: [WoOrderServiceTemplateGridComponent, WoOrderServiceGridComponent, WoOrderServiceDetailComponent, WoOrderOrderServiceDetailComponent, WoOrderServiceDropdownComponent],
    exports: [WoOrderServiceDetailComponent, WoOrderOrderServiceDetailComponent, WoOrderServiceDropdownComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        WoOrderServiceRoutingModule,
        ButtonModule,
        InputTextModule,
        TranslateModule,
        MessageModule,
        MessagesModule,
        TableModule,
        TooltipModule,
        ConfirmDialogModule,
        TabViewModule,
        CardModule,
        DialogModule,
        NotificationsModule,
        InputNumberModule,
        CalendarModule,
        InputMaskModule,
        InputTextModule,
        SfDropDownModule,
        LoaderModule,
        DialogModule,
        ConfirmDialogModule,
        ScModuleModule,
        ProgressSpinnerModule,
        DividerModule,
        SfSubHeaderModule,
        SfBreadCrumbModule,
        ScArchiveTypeModule,
        WoOrderServiceDefaultModule,
        SfDropDownModule,
        DropdownModule,
        ColorPickerModule
    ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, WoOrderService, WoOrderServiceTemplateService]
})
export class WoOrderServiceModule { }


